export default __webpack_public_path__ + "static/media/longduc.58982da9.png";